export const theme = {
  color: {},
  size: {},
};
